export type PayrollPeriodStatus = 'open' | 'pending_close' | 'closed';

export type PayrollPeriodListItem = {
  period_year: number;
  period_month: number;
  status: PayrollPeriodStatus;
};

export function payrollYearMonthKey(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`;
}

export function payrollYearMonthFromYmd(ymd: string): string | null {
  const s = String(ymd ?? '').trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  return s.slice(0, 7);
}

export function buildPayrollPeriodStatusMap(
  items: PayrollPeriodListItem[],
): Map<string, PayrollPeriodStatus> {
  const map = new Map<string, PayrollPeriodStatus>();
  for (const item of items) {
    map.set(payrollYearMonthKey(item.period_year, item.period_month), item.status);
  }
  return map;
}

export function payrollPeriodStatusForYmd(
  ymd: string,
  statusMap: Map<string, PayrollPeriodStatus>,
): PayrollPeriodStatus {
  const ym = payrollYearMonthFromYmd(ymd);
  if (!ym) return 'open';
  return statusMap.get(ym) ?? 'open';
}

export function isClosedPayrollMonth(
  ymd: string,
  statusMap: Map<string, PayrollPeriodStatus>,
): boolean {
  return payrollPeriodStatusForYmd(ymd, statusMap) === 'closed';
}
